import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

let innerWidth = window.innerWidth;
let isDeskTop = false;
let isOpenModal = false;
let FadeHeight = null;
let isTop = false;
const slideCount = 5;
const links = document.querySelectorAll('a[href^="#"]');
const headerHeight = document.querySelector('.headerContents').clientHeight;
const headerItems = document.querySelectorAll('.headerItem');
const menuButton = document.querySelector('.menuButton');
const menuHeaderHeight = document.querySelector('.menuButton').clientHeight;
const menuList = document.querySelector('.menuList');
const menuItems = document.querySelectorAll('.menuItem');
const blockAreas = document.querySelectorAll('.blockArea');
const blockFadeIn = document.querySelectorAll('.blockArea--fadeIn');
const slideItemsDuplicate = document.querySelectorAll('.swiper-slide-duplicate');
const url = location.href;

window.onload = function () {
  if (window.innerWidth >= 768) {
    isDeskTop = true;
  }

  /* swiper */
  let swiper = new Swiper('.swiper-container', {
    slidesPerView: 1,
    breakpoints: {
      769: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 0
      }
    },
    loop: true,
    loopedSlides: 5,
    centeredSlides: false,
    initialSlide: 2,
    autoplay: {
      delay: 5000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
      reverseDirection: false
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  swiper;

  if (url.indexOf('/#') != -1) {
    const id = url.split('/#');
    const target = `#${id[id.length - 1]}`;
    isTop = false;
    anchorScroll(target, isTop);
  }
};

window.addEventListener( 'resize', () => {
  innerWidth = window.innerWidth;
  if (window.innerWidth > 768) {
    isDeskTop = true;
  } else {
    isDeskTop = false;
  }
  let swiper = new Swiper('.swiper-container', {
    slidesPerView: 1,
    breakpoints: {
      769: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 0
      }
    },
    loop: true,
    loopedSlides: 5,
    centeredSlides: false,
    initialSlide: 2,
    autoplay: {
      delay: 5000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
      reverseDirection: false
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  swiper;
});

const anchorScroll = (keyName, isTop) => {
  let elemY = 0;
  let top = 0;
  switch (keyName) {
    case '#':
      top = 0;
      break;
    case '#news':
      elemY = document.querySelector('#news').getBoundingClientRect().top;
      if (isDeskTop) {
        top = window.pageYOffset + elemY - headerHeight;
      } else {
        top = window.pageYOffset + elemY - menuHeaderHeight;
      }
      break;
    case '#clientWorks':
      elemY = document.querySelector('#clientWorks').getBoundingClientRect().top;
      if (isDeskTop) {
        top = window.pageYOffset + elemY - headerHeight;
      } else {
        top = window.pageYOffset + elemY - menuHeaderHeight;
      }
      break;
    case '#salon':
      elemY = document.querySelector('#salon').getBoundingClientRect().top;
      if (isDeskTop) {
        top = window.pageYOffset + elemY - headerHeight;
      } else {
        top = window.pageYOffset + elemY - menuHeaderHeight;
      }
      break;
    case '#address':
      elemY = document.querySelector('#address').getBoundingClientRect().top;
      if (isDeskTop) {
        top = window.pageYOffset + elemY - headerHeight;
      } else {
        top = window.pageYOffset + elemY - menuHeaderHeight;
      }
      break;
    case '#contact':
      elemY = document.querySelector('#contact').getBoundingClientRect().top;
      if (isDeskTop) {
        top = window.pageYOffset + elemY - headerHeight;
      } else {
        top = window.pageYOffset + elemY - menuHeaderHeight;
      }
      break;
    default:
      break;
  }
  if (isTop) {
    window.scroll({
      top: top,
      behavior: 'smooth'
    });
  } else {
    window.scroll({
      top: top,
    });
  }
}

/* anchor scroll  */
links.forEach(item  => {
  item.addEventListener('click', e => {
    e.preventDefault();
    const keyName = item.getAttribute('href');
    isTop = true;
    anchorScroll(keyName, isTop);
  });
});

/* SP: modal */
const menuModalOpen = () => {
  isOpenModal = true;
  menuList.classList.add('modalFadeIn');
  menuList.classList.remove('modalFadeOut');
}

const menuModalClose = () => {
  isOpenModal = false;
  menuList.classList.remove('modalFadeIn');
  menuList.classList.add('modalFadeOut');
}

menuButton.addEventListener('click', e => {
  if (isOpenModal) {
    e.target.classList.add('menuModalOpen');
    e.target.classList.remove('menuModalClose');
    menuModalClose();
  } else {
    e.target.classList.add('menuModalClose');
    e.target.classList.remove('menuModalOpen');
    menuModalOpen();
  }
});

menuItems.forEach((item, i) => {
  item.addEventListener('click', () => {
    menuButton.classList.add('menuModalOpen');
    menuButton.classList.remove('menuModalClose');
    menuModalClose();
  });
});

/* FadeIn animation */
const scrollFadeIn = () => {
  blockFadeIn.forEach(item => {
    let elPosition = item.offsetTop;
    let scrollPosition = window.scrollY;
    let innerHeight = window.innerHeight;
    if (isDeskTop) {
      FadeHeight = 300;
    } else {
      FadeHeight = 200;
    }
    if (scrollPosition > elPosition - innerHeight + FadeHeight){
      item.classList.add('scrollIn');
    }
  });
};
scrollFadeIn();

window.addEventListener('scroll', function(){
  scrollFadeIn();
});
